import tw from "twin.macro";

export const ButtonsWrapper = tw.div`
	tw-w-full
	tw-flex
	tw-justify-end
	tw-gap-8
`;
